<div class="statement-builder-flyout">
  <div class="comment-sidebar">
    <div class="comment-sidebar-header">
      <div class="comment-sidebar-title">
        <i class="fas fa-comment fa-flip-horizontal"></i>
        COMMENT
      </div>
      <div class="comment-sidebar-close" (click)="hideCellInformation()">
        <i class="fas fa-times"></i>
      </div>
    </div>
    <div class="comment-sidebar-content">
      @if (hasComments()) {
        <div class="comment-section">
          @for (sourceComment of cellInformation?.sourceComments; track sourceComment; let last = $last) {
            <div class="comment-item">
              <div>
                <span class="statement-type">{{ getTitle(sourceComment) }}</span>
                <span class="comment-period-date"> | {{ cellInformationStatementDate }}</span>
              </div>
              <div class="comment-text" appFsMask>
                {{ sourceComment.comment }}
              </div>
              <div class="comment-metadata">
                <span class="comment-timestamp">
                  <i class="fas fa-calendar"></i>
                  {{ getCommentTimestamp(sourceComment) }}
                </span>
                <span class="comment-author" appFsMask>
                  <i class="fas fa-user"></i>
                  {{ getCommentAuthor(sourceComment) }}
                </span>
              </div>
              @if (!last) {
                <div class="comment-separator"></div>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="comment-sidebar-footer">
      <div class="separator-line"></div>
      <a class="close-button" (click)="hideCellInformation()">
        Close
      </a>
    </div>
  </div>
</div>